import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { AllAllergies } from "../../Apis/AuthApiServices";
import { loadingAllAllergies, setAllAllergies } from "../Slice/AllergiesSlice";

function* onLoadAllAllergiesAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("patientId", payload.patientId);
  params.append("pageNumber", payload.pageNumber);
  try {
    const result: AxiosResponse = yield AllAllergies(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setAllAllergies({
          AllAllergiesData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setAllAllergies({
          AllAllergiesData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setAllAllergies({
        AllAllergiesData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadAllAllergies() {
  yield takeLatest(loadingAllAllergies.type, onLoadAllAllergiesAsync);
}

const AllAllergiesSaga = [fork(onLoadAllAllergies)];
export default AllAllergiesSaga;
